import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Matt Stayner
 * id 3419199D-CEAB-4084-AB62-A2EA908D40EB
 * name arrow-down-thin
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-thin.svg
 * tags
 * - Arrow 
 */
export const ArrowDownThinIcon = createSvgIcon(<><path d="M7.03 13.92H11.03V5L13.04 4.97V13.92H17.03L12.03 18.92Z" /></>, 'ArrowDownThinIcon');
export default ArrowDownThinIcon